module.exports = __webpack_public_path__ + "media/INTRO.a1232de3.mp4";